export const handle_api_exception = (err) => {
    let output = [];
    let default_output =
        'There was an error processing your request. Please try again in a few moments.';



    if (err.response) {
        if (typeof err.response.data !== 'undefined' && err.response.data) {

            //@assumption : the api always return the messages in the response.data.data
            if (typeof err.response.data.data !== 'undefined') {
                const obj = err.response.data.data;

                if (Array.isArray(obj)) {
                    obj.forEach(({message}) => {
                        output.push(message);
                    });
                } else {
                    Object.keys(obj).forEach((element) => {
                        if (Array.isArray(obj[element])) {
                            obj[element].forEach((message) => {
                                output.push(message);
                            });
                        }
                    });
                }

            }
            //left here so that things dont break 
            if (typeof err.response.data.detail !== 'undefined') {
                const obj = err.response.data.detail;

                if (Array.isArray(obj)) {
                    obj.forEach((message) => {
                        output.push(message);
                    });
                } else {
                    Object.keys(obj).forEach((element) => {
                        if (Array.isArray(obj[element])) {
                            obj[element].forEach((message) => {
                                output.push(message);
                            });
                        }
                    });
                }
            }
        }
    }

    if(output.length ===0) {


        if (err.response) {
            return err.response.data?.message;
        } else if (err.request) {
            console.log(err.request);
        }

        if (
            typeof err.message !== 'undefined' &&
            typeof err.response === 'undefined'
        ) {
            return err.message;
        }

        if (typeof err.data !== 'undefined') {
            return err.data.message;
        }
    }


    if (output.length > 0) {
        return Array.isArray(output) ? output.join(', ') : output;
    } else {
        return default_output;
    }
};
